module.exports = __webpack_public_path__ + "38183334d5ce706476679f81362c127a.MP3";